import { Tooltip } from "@material-ui/core";
import FormatService from "services/formatService";
import {
	DEFAULT_LABEL,
	FLAT_RATE_LABEL,
	VARIES_BY_VEHICLE_TYPE_LABEL,
	TOOLTIP_TITLE,
} from "./PricingByLotConsts";
import { PricingByLotStyle } from "./PricingByLotStyle";
import { useGetVehicleTypesQuery } from "features/vehicles/vehicleSlice";
import { useMemo } from "react";
import { arrayToObject } from "utils/object-util";



const VehicleTypeMarginCell = ({ row }) => {
	const classes = PricingByLotStyle();
	const vehicleTypeMargin = row?.vehicleTypeMargin ?? [];
	const hasVehicleSpecificPricing = vehicleTypeMargin.some((item) => item?.id !== DEFAULT_LABEL);
	const { data: vehicleTypes, isLoading: isLoadingVehicleTypes } = useGetVehicleTypesQuery();
	const vehicleTypeLookup = useMemo(() => arrayToObject(vehicleTypes), [vehicleTypes]);

	if (!hasVehicleSpecificPricing) {
		return (
			<div className={classes.badgeCell}>
				<div className={`${classes.badge} ${classes.badgeDisabled}`}>{FLAT_RATE_LABEL}</div>
			</div>
		);
	}

	const tooltipContent = (
		<div className={classes.tooltip}>
			<div className={classes.tooltipTitle}>{TOOLTIP_TITLE}</div>
			{vehicleTypeMargin.map((item, index) => (
				<div
					className={classes.tooltipRow}
					key={`${item?.id ?? DEFAULT_LABEL}-${index}`}
				>
					<div>{vehicleTypeLookup?.[item?.id]?.name ?? DEFAULT_LABEL}</div>
					<div className={classes.tooltipPrice}>
						{item?.price != null ? FormatService.formatCurrency(item.price) : ""}
					</div>
				</div>
			))}
		</div>
	);

	return (
		<div className={classes.badgeCell}>
			<Tooltip title={tooltipContent} arrow placement="bottom-start" interactive>
				<div className={`${classes.badge} ${classes.badgeInteractive}`}>
					{VARIES_BY_VEHICLE_TYPE_LABEL}
				</div>
			</Tooltip>
		</div>
	);
};

export default VehicleTypeMarginCell;
